import { UpdateTaskMutationBody } from '@api';
import { mapTaskFormAudience, TaskFormSchemaType } from '@common';

type GetUpdateTaskDataArgsType = {
  values: TaskFormSchemaType;
};

export const getUpdateTaskData = ({
  values,
}: GetUpdateTaskDataArgsType): NonNullable<UpdateTaskMutationBody> => ({
  title: values.title.trim(),
  description: values.description.trim(),
  ...(values.priority !== null ? { priority: values.priority } : {}),
  context: values.context === '' ? undefined : values.context,
  audience: mapTaskFormAudience({ values }),
});
